<script setup lang="ts">
/* Types */
import { TabTypes } from '@/types/components/basket-time.types'
import { SetTimePayload } from '@/store/basket/basket.types'

/* Components */
import BasketAvailableTime from '@/components/Basket/basket-time/BasketAvailableTime.vue'
import BasketOnTime from '@/components/Basket/basket-time/BasketOnTime.vue'

type Props = {
  selectedTab: TabTypes
  errorMessage?: string
  warningMessage?: string
  warningIcon?: string
}

defineProps<Props>()

const emit = defineEmits(['update-time'])

const onUpdateTime = (data: SetTimePayload) => {
  emit('update-time', data)
}
</script>

<template>
  <transition v-if="selectedTab === TabTypes.FAST" name="height">
    <basket-available-time
      :error-message="errorMessage"
      :warning-message="warningMessage"
      :warning-icon="warningIcon"
      @update-time="onUpdateTime"
    />
  </transition>

  <transition v-if="selectedTab === TabTypes.DELIVERY_ON_TIME" name="height">
    <basket-on-time
      :error-message="errorMessage"
      :warning-message="warningMessage"
      :warning-icon="warningIcon"
      @update-time="onUpdateTime"
    />
  </transition>
</template>
